import '@Libs/navigator.sendbeacon.min';
import './backward-compatibility';
import '@Plugins/jquery.cookie';
import '@Plugins/icube/install-icube-plugin';
import '@ICubePlugins/body-loader';
import '@ICubePlugins/lazy-html';
import '@Modules/init-ci-message';

import { createAppState } from '@ICube/icube-core';
import { mainRun } from './main';

window.ICUBE_CONFIG = GLOBAL_CONFIG;
createAppState('ICube');
mainRun();